var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-submit-apply",
      attrs: {
        title: _vm.popTitle,
        visible: _vm.visibleDialog,
        width: "650px",
        top: "calc(50vh - 200px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _vm.bonusType == 1
        ? _c(
            "div",
            { staticClass: "apply-form" },
            [
              _c("div", [
                _c("div", { staticClass: "lable" }, [
                  _vm._v("系统判断当前订单的提成类型为"),
                  _c("span", { staticClass: "danger" }, [_vm._v("首购提成")]),
                  _vm._v("，若您认为是"),
                  _c("span", { staticClass: "danger" }, [_vm._v("复购提成")]),
                  _vm._v("请上传证据。"),
                ]),
              ]),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-images",
                      staticStyle: { "line-height": "1" },
                      attrs: { label: "上传图片证据", prop: "fileUrls" },
                    },
                    [
                      _c("div", { staticClass: "info" }, [
                        _vm._v(
                          "（图片最多不超过6张，每张大小不超2M，图片格式支持jpg，jpeg，bmp）"
                        ),
                      ]),
                      _c("upload-picture", {
                        staticClass: "upload-list",
                        attrs: { limit: 6, list: _vm.form.fileUrls },
                        on: { changeImage: _vm.changeImage },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-reason",
                      attrs: { label: _vm.reasonText },
                    },
                    [
                      _c("el-input", {
                        staticClass: "textarea",
                        attrs: {
                          maxlength: "64",
                          rows: 3,
                          "show-word-limit": "",
                          placeholder: "请输入备注",
                          type: "textarea",
                        },
                        model: {
                          value: _vm.form.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "reason", $$v)
                          },
                          expression: "form.reason",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.bonusType == 2
        ? _c(
            "div",
            { staticClass: "apply-form" },
            [
              _c("el-form", { ref: "form", attrs: { model: _vm.form } }, [
                _c("div", { staticClass: "lable" }, [
                  _vm._v("系统判断当前订单的提成类型为"),
                  _c("span", { staticClass: "danger" }, [_vm._v("复购提成")]),
                  _vm._v("，请确认是否修改为"),
                  _c("span", { staticClass: "danger" }, [_vm._v("首购提成")]),
                  _vm._v("。"),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.visibleDialog = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", loading: _vm.btnLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }